import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { installStaleChunkRecovery } from './app/core/runtime/stale-chunk-recovery';

installStaleChunkRecovery();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
